import {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {getAutoProfileGraph} from '@/businesses/autoProfileGraphBusiness';
import {initApp} from '@/businesses/initBusiness';
import {VOLUME_SENSOR_CHART_ADDRESS} from '@/constants/pcConstAppData';

function useRouterLoader() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initApp());
  }, []);

  return {
    [VOLUME_SENSOR_CHART_ADDRESS]: () => dispatch(getAutoProfileGraph()),
  };
}

export default useRouterLoader;
